import { DataTopic } from '@/modules/calendar/model/data/data-topic';
import { CheckboxRow } from '@/shared/components/export';
import { TopicFilter } from '@/modules/calendar/components/data-calendar/topic-filter';

enum ParentState {
  NO_CHILDREN_SELECTED,
  SOME_CHILDREN_SELECT,
  ALL_CHILDREN_SELECTED,
}

function allChildren(topic: DataTopic): DataTopic[] {
  const result: DataTopic[] = [];

  topic.children &&
    topic.children.forEach(value => {
      result.push(value);

      allChildren(value).forEach(value1 => result.push(value1));
    });

  return result;
}

function childrenSelected(topic: DataTopic, selectedTopics: TopicFilter): ParentState {
  if (!topic.children || topic.children.length === 0) return ParentState.NO_CHILDREN_SELECTED;

  const children = allChildren(topic);
  const selectedChildren = children.filter(value => selectedTopics[value.qcode]);
  if (children.length === selectedChildren.length) return ParentState.ALL_CHILDREN_SELECTED;
  else if (selectedChildren.length > 0) return ParentState.SOME_CHILDREN_SELECT;
  else return ParentState.NO_CHILDREN_SELECTED;
}

export function TopicMenu({
  topics,
  selectedTopics,
  onSelectionChange,
}: {
  topics: DataTopic[];
  selectedTopics: TopicFilter;
  onSelectionChange: (s: TopicFilter) => void;
}) {
  const onChange = (checked: boolean) => {
    selectedTopics.allSelected = checked;

    onSelectionChange(new TopicFilter(selectedTopics));
  };

  return (
    <>
      <ul>
        <li>
          <CheckboxRow checked={selectedTopics.allSelected} onChange={onChange} label="All" />
        </li>
      </ul>
      <TopicMenuNode
        selectedTopics={selectedTopics}
        topics={topics}
        onSelectionChange={onSelectionChange}
      ></TopicMenuNode>
    </>
  );
}

export function TopicMenuNode({
  topics,
  selectedTopics,
  onSelectionChange,
}: {
  topics: DataTopic[];
  selectedTopics: TopicFilter;
  onSelectionChange: (s: TopicFilter) => void;
}) {
  const onChildSelect = (s: TopicFilter, parent: DataTopic) => {
    if (childrenSelected(parent, s) === ParentState.ALL_CHILDREN_SELECTED) {
      s[parent.qcode] = true;
    } else s[parent.qcode] = false;

    onSelectionChange(new TopicFilter(s));
  };

  const onChange = (value: boolean, s: DataTopic) => {
    if (value) {
      selectedTopics[s.qcode] = true;
      allChildren(s).forEach(value => (selectedTopics[value.qcode] = true));
    } else {
      selectedTopics[s.qcode] = false;
      allChildren(s).forEach(value => (selectedTopics[value.qcode] = false));
    }

    onSelectionChange(new TopicFilter(selectedTopics));
  };

  return (
    <ul key={`topic-menu-${topics.map(value => value.qcode).join('-')}`}>
      {topics.map(value => {
        const childState = childrenSelected(value, selectedTopics);

        const checked =
          !!selectedTopics[value.qcode] ||
          selectedTopics.allSelected ||
          childState === ParentState.ALL_CHILDREN_SELECTED;
        const indeterminate = !checked && childState === ParentState.SOME_CHILDREN_SELECT;

        return (
          <>
            <li key={`topic-menu-node-${value.qcode}`}>
              <CheckboxRow
                checked={checked}
                indeterminate={indeterminate}
                onChange={next => onChange(next, value)}
                disabled={selectedTopics.allSelected}
                label={value.name}
              />
            </li>

            {value.children && (
              <li key={`topic-menu-children-${value.qcode}`}>
                <TopicMenuNode
                  topics={value.children}
                  selectedTopics={selectedTopics}
                  onSelectionChange={s => onChildSelect(s, value)}
                />
              </li>
            )}
          </>
        );
      })}
    </ul>
  );
}
